import React from 'react';
import CertificateListPage from '@/temu-platform/modules/certificates/CertificateListPage';
import '@/styles/temu-platform/temu-product-ops.css';

const CERT_SYNC_KINDS = ['certificate', 'certAutoBind'];

/**
 * 合规资质 · 产品证书资质（SPU 维度）
 * ① cert.query 拉待上传证书类型 → ② queryNeedUploadItems → ③ uploadProductCert。
 */
export default function CertificateBindPage() {
  return (
    <CertificateListPage
      active
      initialFilter="all"
      syncKinds={CERT_SYNC_KINDS}
    />
  );
}
